import {css} from "@emotion/react";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {HeartIcon} from "@pg-design/icons-module";
import {TextVariantUnionType} from "@pg-design/text";
import {Text} from "@pg-design/text-module";

import {hitGTMOfferAddToWishlist, IHitGTMOfferWishlistParams} from "../../offer/tracking/ecommerce_events/offer/hit_gtm_offer_add_to_wishlist";
import {hitGTMPropertyAddToWishlist, IHitGTMPropertyAddToWishlistParams} from "../../offer/tracking/ecommerce_events/property/hit_gtm_property_add_to_wishlist";
import {handleFavouritesListCheckHit} from "../../tracking/algolytics_hits/favourites_list_hit";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useFavourites} from "../hooks/use_favourites";
import {hitGtmAddToCompareClick} from "../tracking/favourite_gtm_events";
import {gtmFavouriteAddToFavouritesClick} from "../tracking/gtm_event_favourites_multilead";

interface IProps {
    offer: {id: number} & IHitGTMOfferWishlistParams["offer"];
    property?: {id: number} & IHitGTMPropertyAddToWishlistParams["property"];
    display: IButtonDisplay | IIconButtonDisplay;
    className?: string;
    dataTestId?: string;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

type IButtonDisplay = {type: "button"; size: "s" | "m" | "l"};
type IIconButtonDisplay = {type: "icon"};

export function FavoriteButton(props: IProps) {
    const {offer, property, display, className, dataTestId, amplitudePlacement} = props;

    /**
     * Currently it's based on favourites, because first we check this in AB as mvp.
     * In case AB's passed, move it to new implementation.
     */
    const {
        isOfferInFavourites,
        isPropertyInFavourites,
        addPropertyToFavourites,
        addOfferToFavourites,
        removePropertyFromFavourites,
        removeOfferFromFavourites
    } = useFavourites();

    const isSubscribed = property?.id ? isPropertyInFavourites(property.id) : isOfferInFavourites(offer.id);

    const onFavouriteToggle = async () => {
        const {offer, property} = props;

        if (property?.id && isSubscribed) {
            await removePropertyFromFavourites(property.id);

            hitGtmAddToCompareClick(false);
            handleFavouritesListCheckHit(false, offer.id, property.id);
        } else if (!property?.id && isSubscribed) {
            await removeOfferFromFavourites(offer.id);

            gtmFavouriteAddToFavouritesClick(false);
            handleFavouritesListCheckHit(false, offer.id);
        } else if (property?.id && !isSubscribed) {
            await addPropertyToFavourites(property.id, offer.id, undefined, amplitudePlacement);

            hitGtmAddToCompareClick(true);
            hitGTMPropertyAddToWishlist({offer, property});
            handleFavouritesListCheckHit(true, offer.id, property.id);
        } else {
            //  !propertyId && !isInFavourites
            await addOfferToFavourites(offer.id, amplitudePlacement);

            gtmFavouriteAddToFavouritesClick(true);
            hitGTMOfferAddToWishlist({offer});
            handleFavouritesListCheckHit(true, offer.id);
        }
    };

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onFavouriteToggle();
    };

    if (display.type === "icon") {
        return (
            <Button
                className={className}
                css={iconButton}
                dataTestId={dataTestId}
                iconLeft={HeartIcon}
                onClick={handleClick}
                size="x-small"
                variant={isSubscribed ? "filled_secondary" : "filled_primary"}
            />
        );
    }

    return (
        <Button
            className={className}
            css={subscribeButton}
            iconLeft={HeartIcon}
            onClick={handleClick}
            size={getButtonSize(display.size)}
            variant={isSubscribed ? "filled_secondary" : "outlined_secondary"}
        >
            <Text variant={getButtonTextSize(display.size)}>{isSubscribed ? "W ulubionych" : "Dodaj do ulubionych"}</Text>
        </Button>
    );
}

// Styles
const subscribeButton = css`
    flex: 1 0 auto;
`;

const iconButton = css`
    flex: 1 0 auto;
    width: 40px;
    min-width: unset;
`;

// Utils
function getButtonSize(size: IButtonDisplay["size"]): IButtonSizePrimary {
    if (size === "m") {
        return "small";
    }

    if (size === "l") {
        return "medium";
    }

    return "x-small";
}

function getButtonTextSize(size: IButtonDisplay["size"]): TextVariantUnionType {
    if (size === "m") {
        return "button_small";
    }

    if (size === "l") {
        return "button_medium";
    }

    return "button_small";
}
import {css} from "@emotion/react";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {HeartIcon} from "@pg-design/icons-module";
import {TextVariantUnionType} from "@pg-design/text";
import {Text} from "@pg-design/text-module";

import {hitGTMOfferAddToWishlist, IHitGTMOfferWishlistParams} from "../../offer/tracking/ecommerce_events/offer/hit_gtm_offer_add_to_wishlist";
import {hitGTMPropertyAddToWishlist, IHitGTMPropertyAddToWishlistParams} from "../../offer/tracking/ecommerce_events/property/hit_gtm_property_add_to_wishlist";
import {handleFavouritesListCheckHit} from "../../tracking/algolytics_hits/favourites_list_hit";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useFavourites} from "../hooks/use_favourites";
import {hitGtmAddToCompareClick} from "../tracking/favourite_gtm_events";
import {gtmFavouriteAddToFavouritesClick} from "../tracking/gtm_event_favourites_multilead";

interface IProps {
    offer: {id: number} & IHitGTMOfferWishlistParams["offer"];
    property?: {id: number} & IHitGTMPropertyAddToWishlistParams["property"];
    display: IButtonDisplay | IIconButtonDisplay;
    className?: string;
    dataTestId?: string;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

type IButtonDisplay = {type: "button"; size: "s" | "m" | "l"};
type IIconButtonDisplay = {type: "icon"};

export function FavoriteButton(props: IProps) {
    const {offer, property, display, className, dataTestId, amplitudePlacement} = props;

    /**
     * Currently it's based on favourites, because first we check this in AB as mvp.
     * In case AB's passed, move it to new implementation.
     */
    const {
        isOfferInFavourites,
        isPropertyInFavourites,
        addPropertyToFavourites,
        addOfferToFavourites,
        removePropertyFromFavourites,
        removeOfferFromFavourites
    } = useFavourites();

    const isSubscribed = property?.id ? isPropertyInFavourites(property.id) : isOfferInFavourites(offer.id);

    const onFavouriteToggle = async () => {
        const {offer, property} = props;

        if (property?.id && isSubscribed) {
            await removePropertyFromFavourites(property.id);

            hitGtmAddToCompareClick(false);
            handleFavouritesListCheckHit(false, offer.id, property.id);
        } else if (!property?.id && isSubscribed) {
            await removeOfferFromFavourites(offer.id);

            gtmFavouriteAddToFavouritesClick(false);
            handleFavouritesListCheckHit(false, offer.id);
        } else if (property?.id && !isSubscribed) {
            await addPropertyToFavourites(property.id, offer.id, undefined, amplitudePlacement);

            hitGtmAddToCompareClick(true);
            hitGTMPropertyAddToWishlist({offer, property});
            handleFavouritesListCheckHit(true, offer.id, property.id);
        } else {
            //  !propertyId && !isInFavourites
            await addOfferToFavourites(offer.id, amplitudePlacement);

            gtmFavouriteAddToFavouritesClick(true);
            hitGTMOfferAddToWishlist({offer});
            handleFavouritesListCheckHit(true, offer.id);
        }
    };

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onFavouriteToggle();
    };

    if (display.type === "icon") {
        return (
            <Button
                className={className}
                css={iconButton}
                dataTestId={dataTestId}
                iconLeft={HeartIcon}
                onClick={handleClick}
                size="x-small"
                variant={isSubscribed ? "filled_secondary" : "filled_primary"}
            />
        );
    }

    return (
        <Button
            className={className}
            css={subscribeButton}
            iconLeft={HeartIcon}
            onClick={handleClick}
            size={getButtonSize(display.size)}
            variant={isSubscribed ? "filled_secondary" : "outlined_secondary"}
        >
            <Text variant={getButtonTextSize(display.size)}>{isSubscribed ? "W ulubionych" : "Dodaj do ulubionych"}</Text>
        </Button>
    );
}

// Styles
const subscribeButton = css`
    flex: 1 0 auto;
`;

const iconButton = css`
    flex: 1 0 auto;
    width: 40px;
    min-width: unset;
`;

// Utils
function getButtonSize(size: IButtonDisplay["size"]): IButtonSizePrimary {
    if (size === "m") {
        return "small";
    }

    if (size === "l") {
        return "medium";
    }

    return "x-small";
}

function getButtonTextSize(size: IButtonDisplay["size"]): TextVariantUnionType {
    if (size === "m") {
        return "button_small";
    }

    if (size === "l") {
        return "button_medium";
    }

    return "button_small";
}
